// This file is automatically generated. Do not edit manually.

import { ProductChangeRequestView } from "src/api/generated/erp/db/types/tables/productChangeRequestView";
import { ProductChangeCatalogPartRevisionView } from "src/api/generated/erp/db/types/tables/productChangeCatalogPartRevisionView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeConnectionsApi {
	export async function getConnectedRequests(args: {
		productChangeId: number;
	}): Promise<Array<ProductChangeRequestView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/getConnectedRequests",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
			},
		});
		return response as Array<ProductChangeRequestView>;
	}

	export async function connectRequests(args: {
		productChangeId: number;
		productChangeRequestIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/connectRequests",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
				productChangeRequestIds: args.productChangeRequestIds,
			},
		});
		return response as void;
	}

	export async function disconnectRequests(args: {
		productChangeId: number;
		productChangeRequestIds: Array<number>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/disconnectRequests",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
				productChangeRequestIds: args.productChangeRequestIds,
			},
		});
		return response as number;
	}

	export async function getConnectedCatalogPartRevisions(args: {
		productChangeId: number;
	}): Promise<Array<ProductChangeCatalogPartRevisionView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/getConnectedCatalogPartRevisions",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
			},
		});
		return response as Array<ProductChangeCatalogPartRevisionView>;
	}

	export async function connectCatalogPartRevisions(args: {
		productChangeId: number;
		catalogPartRevisionIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/connectCatalogPartRevisions",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
				catalogPartRevisionIds: args.catalogPartRevisionIds,
			},
		});
		return response as void;
	}

	export async function disconnectCatalogPartRevisions(args: {
		productChangeId: number;
		catalogPartRevisionIds: Array<number>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/connections/disconnectCatalogPartRevisions",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
				catalogPartRevisionIds: args.catalogPartRevisionIds,
			},
		});
		return response as number;
	}
}
